import React, {FC} from 'react'
import {IMicroLearning} from '../../../../interfaces'
import {TContributorSection} from '../../../../interfaces/Contributor.interface'
import {LIST_CONTRIBUTOR_MICROLEARNING} from '../../../../provider/services/LearningContributor.service'
import {LearningType} from '../../../../utils/enum'
import NoListComponent from '../../../empty-state/NoList.component'
import LoadingCircular from '../../../loading/LoadingCircular.component'
import LearnerCatalogCard from '../../catalog/LearnerCatalogCard.component'

const MicroLearning: FC<TContributorSection> = ({id, search, sort}) => {
  const {data, loading} = LIST_CONTRIBUTOR_MICROLEARNING(search, id, sort)

  if (loading) {
    return <LoadingCircular height="500px" />
  }

  return data?.microlearnings.length === 0 ? (
    <div className="flex flex-col justify-center" style={{height: 500}}>
      <NoListComponent
        title="Maaf, tidak ada daftar"
        subTitle="Pembelajaran Mikro tidak ditemukan"
      />
    </div>
  ) : (
    <div className="flex flex-wrap -mx-3">
      {data?.microlearnings.map((item: IMicroLearning, i: number) => (
        <LearnerCatalogCard
          type={LearningType.MICRO_LEARNING}
          item={item}
          key={i}
          hidePrice={false}
        />
      ))}
    </div>
  )
}

export default MicroLearning
